import { Component, Input } from '@angular/core';

/** SVG path data for the Document Finder icon set (16×16 viewBox, stroked). */
export const DF_ICONS: Record<string, string[]> = {
    search: ['M11 11l3.5 3.5M7 12.5A5.5 5.5 0 1 0 7 1.5a5.5 5.5 0 0 0 0 11z'],
    hist: ['M2 8a6 6 0 1 0 1.8-4.3M2 2v3.5h3.5M8 5v3.3l2.2 1.4'],
    pack: ['M2 5l6-3 6 3v6l-6 3-6-3zM2 5l6 3 6-3M8 8v6'],
    map: ['M3 3h4v4H3zM9 9h4v4H9zM5 7v3.5a.5.5 0 0 0 .5.5H9'],
    tax: ['M2 3h12M2 8h8M2 13h10'],
    fb: ['M2 3h12v8H6l-4 3z'],
    help: ['M2 8a6 6 0 1 0 12 0a6 6 0 1 0-12 0', 'M6.3 6.2a1.8 1.8 0 1 1 2.5 1.7c-.5.2-.8.6-.8 1.1v.4M8 11.6v.1'],
    set: ['M5.8 8a2.2 2.2 0 1 0 4.4 0a2.2 2.2 0 1 0-4.4 0', 'M8 1.5v2M8 12.5v2M1.5 8h2M12.5 8h2M3.4 3.4l1.4 1.4M11.2 11.2l1.4 1.4M3.4 12.6l1.4-1.4M11.2 4.8l1.4-1.4'],
    spark: ['M8 1.5l1.6 4.9 4.9 1.6-4.9 1.6L8 14.5l-1.6-4.9L1.5 8l4.9-1.6z'],
    check: ['M3 8.5l3 3 7-7'],
    x: ['M4 4l8 8M12 4l-8 8'],
    eye: ['M1.5 8S4 3.5 8 3.5 14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8z', 'M6 8a2 2 0 1 0 4 0a2 2 0 1 0-4 0'],
    plus: ['M8 3v10M3 8h10'],
    dl: ['M8 2v8M4.5 7 8 10.5 11.5 7M2.5 13.5h11'],
    up: ['M8 14V6M4.5 9 8 5.5 11.5 9M2.5 2.5h11'],
    link: ['M6.5 9.5l3-3M7 4.5l1-1a2.8 2.8 0 0 1 4 4l-1 1M9 11.5l-1 1a2.8 2.8 0 0 1-4-4l1-1'],
    collapse: ['M9 3 4 8l5 5M13 3 8 8l5 5']
};

@Component({
    selector: 'df-icon',
    template: `<svg [attr.width]="size" [attr.height]="size" viewBox="0 0 16 16" fill="none" stroke="currentColor"
        [attr.stroke-width]="strokeWidth" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path *ngFor="let d of paths" [attr.d]="d"></path>
    </svg>`,
    styleUrls: ['./df-icon.component.scss'],
    standalone: false
})
export class DfIconComponent {
    @Input() name: string = '';
    @Input() size: number = 16;
    @Input() strokeWidth: number = 1.6;

    public get paths(): string[] {
        return DF_ICONS[this.name] ?? [];
    }
}
